import service from "./service";

export default {
    validateCredentials(username, password, type) {
        return service.post('/user/login/validate', {
            username: username,
            password: password,
            type: type,
        });
    },

    validateQR(qr, type) {
        return service.post('/user/login/validate', {
            qr: qr,
            type: type,
        });
    },

    validateAccount(value, type) {
        return service.post('/user/login/validate', {
            value: value,
            type: type,
        });
    },

    validateSerial(value, type) {
        return service.post('/user/login/validate', {
            value: value,
            type: type,
        });
    },

    validatePin(pin, hash, type, uuid) {
        return service.post('user/login/' + uuid + '/pin', {
            pin: pin,
            hash: hash,
            type: type,
        });
    },

    createSession(hash, username, password, type) {
        return service.post('/user/login', {
            hash: hash,
            username: username,
            password: password,
            type: type,
            attempt: 1,
        });
    },

    createSessionQR(hash, qr, type) {
        return service.post('/user/login', {
            hash: hash,
            qr: qr,
            type: type,
            attempt: 1,
        });
    },

    createSessionAccount(hash, value, type) {
        return service.post('/user/login', {
            hash: hash,
            value: value,
            type: type,
            attempt: 1,
        });
    },

    createSessionSerial(hash, value, type) {
        return service.post('/user/login', {
            hash: hash,
            value: value,
            type: type,
            attempt: 1,
        });
    },

    createSessionHash(hash) {
        return service.post('/user/login', {
            hash: hash,
            attempt: 1,
        });
    },

    recoverSession(hash){
        return service.post('/user?hash=' + hash);
    },

    destroySession(hash){
        return service.delete('/user/logout', {
            hash: hash,
        })
        
    },

    validateMobile(hash, mobile, uuid){
        return service.post('user/' + uuid + '/mobile', {
            hash: hash,
            value: mobile
        });
    },

    validateEmail(hash, email, uuid){
        return service.post('user/' + uuid + '/email', {
            hash: hash,
            value: email
        });
    },
    
    requestMobileOTP(mobile, type, pin){
        return service.post('/support/otp', {
            mobile: mobile,
            type: type,
            pin: pin,
        });
    },

    requestEmailOTP(email, name, type, pin){
        return service.post('/support/otp', {
            email: email,
            name: name,
            type: type,
            pin: pin,
        });
    },

    validateOTP(otp, pin, type){
        return service.post('/support/otp/validate', {
            otp: otp,
            pin: pin,
            type: type,
        });
    },

    editMobile(hash, mobile, token, pin, uuid, update_key){
        return service.put('user/' + uuid + '/mobile', {
            hash: hash,
            value: mobile,
            otp_token: token,
            otp_pin: pin,
            update_key: update_key,
        });
    },

    editEmail(hash, email, token, pin, uuid, update_key){
        return service.put('user/' + uuid + '/email', {
            hash: hash,
            value: email,
            otp_token: token,
            otp_pin: pin,
            update_key: update_key,
        });
    },

    editTIN(hash, tin, key){
        return service.put('member/' + key + '/tin', {
            hash: hash,
            value: tin
        });
    },

    editBirthdate(hash, month, day, year, key){
        return service.put('member/' + key + '/date-of-birth', {
            hash: hash,
            month: parseInt(month),
            day: parseInt(day),
            year: parseInt(year),
        });
    },

    createTransactionRequest(hash, type, uuid, key){
        return service.post('user/' + uuid + '/transaction', {
            hash: hash,
            type: type,
            key: key, 
        })
    },

    // fetchTransactionRequest(hash, reference, type, uuid, key){
    //     return service.post('user/' + uuid + '/transaction/' + type, {
    //         hash: hash,
    //         reference: reference,
            
    //     })
    // },

    submitRating(hash, type, score, uuid, kiosk_id, remarks){
        return service.post('support/' + uuid + '/rating', {
            hash: hash,
            type: type,
            score: score,
            reference: kiosk_id,
            remarks: remarks
        });
    },

    fetchBalances(hash, uuid, reference){
        return service.post('user/' + uuid + '/balances', {
            hash: hash,
            reference: reference
        });
    },

    validateOldPIN(hash, uuid, pin){
        return service.post('user/' + uuid + '/pin', {
            hash: hash,
            uuid: uuid,
            pin: pin,
        });
    },

    editPIN(hash, uuid, old_pin, new_pin){
        return service.put('user/' + uuid + '/pin', {
            hash: hash,
            pin: old_pin,
            value: new_pin,
        });
    },
    enrollPIN(hash, uuid, otp_token, otp_pin, value, pin, type){
        return service.post('user/' + uuid + '/pin/enroll', {
            hash: hash,
            otp_token: otp_token,
            otp_pin: otp_pin,
            pin: pin,
            value: value,
            type: type,
        });
    },

    requestPINOTP(mobile, email, name, type){
        return service.post('/support/otp', {
            mobile: mobile,
            email: email,
            name: name,
            type: type,
        });
    },
}